// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".capitalize[data-v-75cb04b0]{text-transform:capitalize}.list-table-wrapper[data-v-75cb04b0]{height:calc(100% - 60px);overflow-y:scroll;box-shadow:0 0 5px rgba(0,0,0,0.25)}ul.pagination.b-pagination[data-v-75cb04b0]{position:absolute;bottom:0;left:50%;transform:translateX(-50%)}.queryDati-wrapper[data-v-75cb04b0]{width:35px;display:flex;justify-content:center;align-items:center;padding-left:10px;cursor:pointer;font-size:1.2rem}\n", ""]);
// Exports
module.exports = exports;
